import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @mui/material components
import Box from "@mui/material/Box";

// sx styles (migrated from JSS cardStyle.js — Faz 7)
const cardSx = {
  border: "0",
  marginBottom: "30px",
  marginTop: "30px",
  borderRadius: "6px",
  color: "rgba(0, 0, 0, 0.87)",
  background: "#fff",
  width: "100%",
  boxShadow:
    "0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  minWidth: "0",
  wordWrap: "break-word",
  fontSize: ".875rem",
  transition: "all 300ms linear"
};
const cardPlainSx = {
  background: "transparent",
  boxShadow: "none"
};
const cardCarouselSx = {
  overflow: "hidden"
};

export default function Card(props) {
  const { className, children, plain, carousel, ...rest } = props;
  const sx = {
    ...cardSx,
    ...(plain ? cardPlainSx : {}),
    ...(carousel ? cardCarouselSx : {})
  };
  return (
    <Box className={className} sx={sx} {...rest}>
      {children}
    </Box>
  );
}

Card.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  carousel: PropTypes.bool,
  children: PropTypes.node
};
